// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "DiscountAppComponents-i18n" + "." + "ec9d0233" + ".chunk.js";
};